<template>
    <div class="operation_box">
        <!-- Document Download -->
        <div class="operation_item" v-if="shouldDisplayDownloadButton">
            <el-dropdown split-button type="primary"
                         @click="handleDocumentsDownload"
                         @command="(command) => command()"
            >
                <i class="fa fa-cloud-download"></i>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item icon="fa fa-cloud-download" :command="handleDocumentsDownload">
                        <span>{{ $t("common.all") }}</span>
                    </el-dropdown-item>
                    <el-dropdown-item v-for="doc in availableAssignmentDocuments"
                                      :key="doc.type"
                                      :icon="doc.property.icon"
									  :disabled="!doc.fileUrl"
					>
                        <a :href="doc.fileUrl" target="_blank" :disabled="!doc.fileUrl">
                            {{ $t(doc.property.key) }}
                        </a>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>
<script>

import {enumDef} from "@/common/enumDefs";
import {fileuploadApi} from "@/common/api/fileuploadApi";

export default {
    data() {
        return {
            enumDef: enumDef,
        };
    },
    computed: {
    	shouldDisplayDownloadButton() {
			return this.params.data.assignmentId
        },
		availableAssignmentDocuments() {
			return Object.keys(enumDef.assignmentDocumentType.properties)
				.map(key => {
					let type = Number(key);
					return {
						type: type,
						property: enumDef.assignmentDocumentType.properties[key],
						fileUrl: this.buildDocumentDownloadUrl(type)
					}
				});
		}
    },
    methods: {
        handleDocumentsDownload() {
            this.params.downloadDocuments(this.params.data);
        },
        buildDocumentDownloadUrl(documentType) {
            let fileId;

            switch (documentType) {
                case enumDef.assignmentDocumentType.AssignmentContract:
                    fileId = this.params.data.assignmentDocumentFileId;
                    break;
				case enumDef.assignmentDocumentType.AssignmentAdditionalDocument:
					fileId = this.params.data.assignmentAdditionalDocumentFileId;
					break;
                case enumDef.assignmentDocumentType.AdviceOfSettlement:
                    fileId = this.params.data.assignmentInvoiceDocumentFileId;
                    break;
                case enumDef.assignmentDocumentType.ServiceInvoice:
                    fileId = this.params.data.assignmentServiceInvoiceDocumentFileId;
                    break;
	            case enumDef.assignmentDocumentType.DiscountInvoice:
		            fileId = this.params.data.assignmentDiscountInvoiceDocumentFileId;
		            break;
                case enumDef.assignmentDocumentType.AccountingCsv:
                    fileId = this.params.data.accountingCsvDocumentFileId;
                    break;
            }

			if (!fileId) {
				return null;
			}

            return fileuploadApi.getPdfUrl(fileId);
        },
    }
};
</script>